import type { CandidateVacancy } from '../types';

type CandidatePaymentPeriod = NonNullable<CandidateVacancy['paymentPeriod']>;

export function mockCandidatePaymentPeriod(
  overrides: Partial<CandidatePaymentPeriod> = {}
): CandidatePaymentPeriod {
  return {
    id: 1,
    name: 'Monthly',
    ...overrides,
  };
}
